
import { supabase } from "@/integrations/supabase/client";
import { CaseFormData } from "@/components/cases/CaseForm";

export async function createCase(values: CaseFormData, userId: string) {
  try {
    console.log('Starting case creation with values:', values);
    
    // Generate workflow using Supabase Edge Function
    const { data: workflowData, error: workflowError } = await supabase.functions.invoke(
      'generate-workflow',
      {
        body: {
          title: values.title,
          description: values.description || '',
        },
      }
    );

    if (workflowError) {
      console.error('Workflow generation error:', workflowError);
      throw workflowError;
    }

    if (!workflowData?.workflow) {
      console.error('No workflow data received:', workflowData);
      throw new Error('No workflow was generated');
    }

    console.log('Generated workflow:', workflowData.workflow);

    // Format the deadline date as an ISO string if it exists
    const deadline = values.deadline ? values.deadline.toISOString() : null;

    // Create the case with the generated workflow and deadline information
    const { data: caseData, error: caseError } = await supabase
      .from("cases")
      .insert({
        title: values.title,
        description: values.description || null,
        user_id: userId,
        workflow: workflowData.workflow,
        deadline: deadline,
        deadline_notification_email: values.deadline_notification_email,
        deadline_notification_days: values.deadline_notification_days,
      })
      .select()
      .single();

    if (caseError) {
      console.error('Case creation error:', caseError);
      throw caseError;
    }

    // If email notifications are enabled, create a notification record
    if (deadline && values.deadline_notification_email) {
      const notificationDate = new Date(values.deadline);
      notificationDate.setDate(notificationDate.getDate() - values.deadline_notification_days);

      const { error: notificationError } = await supabase
        .from('case_deadline_notifications')
        .insert({
          case_id: caseData.id,
          user_id: userId,
          notification_type: 'deadline',
          scheduled_for: notificationDate.toISOString(),
        });

      if (notificationError) {
        console.error('Error creating notification:', notificationError);
        // Don't throw here, as the case was created successfully
      }
    }

    console.log('Case created successfully:', caseData);
    return caseData;
  } catch (error) {
    console.error('Error in createCase:', error);
    throw error;
  }
}
